import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import ChannelGrid from "./ChannelGrid";
import CardMedia from "@mui/material/CardMedia";

const styles = {
  myFreeContainerStyles: {
    borderRadius: "2px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    p: "12px 48px",
    gap: "8px",
    width: "100%",
    cursor: "pointer"
  },
  logoContainer: {
    width: {
      xs: "56px",
      sm: "72px",
      md: "97px"
    },
    height: {
      xs: "16px",
      sm: "20px",
      md: "27px"
    }
  },
  arrowStyles: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    transition: "transform 0.3s ease-in-out"
  },
  logoBodyContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px"
  },
  channelsGridAnimationContainer: {
    pt: "12px",
    transformOrigin: "top",
    transition:
      "max-height 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.3s, transform 0.3s",
    overflow: "hidden",
    willChange: "max-height, opacity, transform"
  }
};

const ModalMyFreeSection = (props: any) => {
  const { id: _id, logo, alt, body, downArrow, background, channels } = props;
  const [showMyFreeChannels, setShowMyFreeChannels] = React.useState(false);
  try {
    return (
      <>
        {channels?.length > 0 && (
          <DtvBox
            sx={{
 width: "100%",
display: "flex",
flexDirection: "column"
}}
          >
            {/* MyFree Logo | Body Text | Show Channels Toggle */}
            <DtvBox aria-label="Show My Free Channels"
              role="button"
              tabIndex={0}
              sx={{
 ...styles.myFreeContainerStyles,
background
}}
              onClick={() => setShowMyFreeChannels(!showMyFreeChannels)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  setShowMyFreeChannels(!showMyFreeChannels);
                }
              }}
            >
              <DtvBox sx={{ ...styles.logoBodyContainer }}>
                {/* logo container */}
                {logo && (
                  <DtvBox
                    aria-label={"My Free Directv"}
                    id="icon-container"
                    sx={{ ...styles.logoContainer }}
                    tabIndex={-1}
                  >
                    {/* logo */}
                    <CardMedia
                      alt={alt || `My Free Directv logo`}
                      aria-labelledby={`icon-container-my-free-directv`}
                      component={"img"}
                      loading="lazy"
                      src={`${logo}`}
                    />
                  </DtvBox>
                )}
                {/* body text */}
                {body?.content && <DtvText {...body} />}
              </DtvBox>
              {/* show channels toggle arrow */}
              <CardMedia
                alt={`down arrow icon`}
                aria-labelledby={`icon-container-my-free-directv`}
                component={"img"}
                loading="lazy"
                src={
                  downArrow?.icon ||
                  "https://www.directv.com/dtvassets/global/icons/2022/arrow-down_lt-bg.svg"
                }
                sx={{
                  ...styles.arrowStyles,
                  transform: showMyFreeChannels ?
                    "rotate(180deg)" :
                    "rotate(0deg)"
                }}
              />
            </DtvBox>
            {/* Channels Grid with Animation */}
            <DtvBox
              data-testid="channel-grid"
              sx={{
                opacity: showMyFreeChannels ? 1 : 0,
                transform: showMyFreeChannels ? "scaleY(1)" : "scaleY(0.95)",
                ...styles.channelsGridAnimationContainer
              }}
            >
              {showMyFreeChannels && <ChannelGrid channels={channels} />}
            </DtvBox>
          </DtvBox>
        )}
      </>
    );
  } catch (error) {
    return <ErrorDisplay component="ModalMyFreeSection" error={error} />;
  }
};

export default React.memo(ModalMyFreeSection);
